export const gridProperties = {
  columnGap: 16,
  rowGap: 24
}
